import { HTTP } from '@/api';

export default {
  getCrawlerSettings({ commit }) {
    commit('isLoading', {
      key: 'crawlerSettings',
      status: true,
    });
    return HTTP.get('/data').then((res) => {
      let data = res.data;
      if (data.success) commit('setCrawlerSettings', data.result);
      return !!data;
    });
  },
  saveCrawlerSettings({ state }, channel) {
    const obj = state.data.settings.find(
      (s) => s.channel === channel
    );
    if (!obj) throw Error('Wrong channel specified');
    return HTTP.post('/data', obj).then((res) => {
      let data = res.data;
      if (data.success === false) {
        throw new Error(data.message);
      }
    });
  },
};
